// orchestrator_fullstack/frontend/src/app/ingress/tenant.ts

export const ROOT_TENANT_UUID = "00000000-0000-0000-0000-000000000001";
export const DEFAULT_TENANT_LABEL = "root";

/**
 * Try to derive tenant UUID from the canonical auth snapshot first,
 * then fall back to legacy localStorage keys, then root UUID.
 */
export function getTenantUuid(): string {
  // 1) Canonical: orchestrator.authme (written by AuthProvider)
  try {
    const raw = localStorage.getItem("orchestrator.authme");
    if (raw) {
      const parsed = JSON.parse(raw);
      const tid = parsed?.me?.tenant || parsed?.me?.claims?.tenant_id;
      if (typeof tid === "string" && tid.trim().length >= 32) {
        return tid.trim();
      }
    }
  } catch {
    // ignore
  }

  // 2) Legacy explicit key
  try {
    const v = localStorage.getItem("tenant_uuid");
    if (v && v.trim().length >= 32) return v.trim();
  } catch {
    // ignore
  }

  // 3) Safe fallback (matches prior behavior)
  return ROOT_TENANT_UUID;
}

/**
 * Best-effort label for UI. Keep legacy behavior.
 * NOTE: label is NOT used for RLS; UUID is the canonical tenant identity.
 */
export function getTenantLabel(): string {
  try {
    const v =
      localStorage.getItem("tenant_label") ||
      localStorage.getItem("tenant") ||
      DEFAULT_TENANT_LABEL;
    return String(v || DEFAULT_TENANT_LABEL).toString();
  } catch {
    return DEFAULT_TENANT_LABEL;
  }
}